import './App.css'; // poooooooooooo
import React, { useState } from 'react';
import matteoselfie from './matteo_gown.jpg';
import matteoproffesional from './matteo_suit.jpg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome, faUser, faCode, faBriefcase, faProjectDiagram, faEnvelope, faCogs, faDatabase, faServer, faCopyright, faArrowLeft,faArrowRight, faFolder} from '@fortawesome/free-solid-svg-icons';
import { faLinkedin, faGithub, faPython, faHtml5, faJava,faReact, faJs, faCss3} from '@fortawesome/free-brands-svg-icons';
import { faAws } from '@fortawesome/free-brands-svg-icons';
import { faGit } from '@fortawesome/free-brands-svg-icons/faGit';

function App() {
  const [slideIndex, setSlideIndex] = useState(0);
  const slides = [
    {
      title: "The Moyie Nightshift",
      content: "The Moyie Nightshift is a first-person atmospheric horror game built in Godot, set aboard a paddlewheel ship stranded at sea. The game focuses on exploration, environmental storytelling, and mounting tension as the player navigates the ship’s dark, decaying rooms in search of a way out. The Steam page will be released soon.",
      link: ""
    },
    { title: "Blackjack.io", content: "Blackjack.io is a modern take on the classic card game, designed to bring players together in a seamless online experience. In an age where physical distance often separates us, Blackjack.io provides an engaging and accessible platform for friends and enthusiasts to enjoy a timeless game from anywhere.", link:"https://www.blackjackio.ca/" 
    },
    { title: "CPSC481 Degree Planner", content: "CPSC481 Degree Planner is a customizable academic planning tool developed to help students visualize and organize their university courses over a 4-year period. Built with a focus on clarity and flexibility, the planner allows users to assign courses to specific terms, categorize them by type and view their academic progression at a glance. This tool is especially helpful for students trying to meet graduation requirements while balancing electives and major-specific classes. The project is designed to be easily extended or adapted for different programs or institutions.", link:"https://github.com/matt200500/cpsc481degreeplanner" 
    },
    { title: "Universal Library Database", content: "The Universal Library is a database made in Django that keeps track of seats, books, rooms, and events that are held within the library.  Utilizing React, Javascript, and HTML, the website is both functional for users and for administrators changing the data within.", link:"https://github.com/matt200500/CPSC471-Universal-Library" 
      
    },
    { title: "Trivia Quiz", content: "Online quiz built with vanilla javascript which changes difficulty and category according to user skill",link:"https://github.com/matt200500/trivia-quiz" },
    { title: "TCP Webserver", content: "Creates a Local TCP server, allowing clients to connect and create GET requests.  Utilizes Java Sockets.",link:"https://github.com/matt200500/TCP-Webserver" },
    { title: "Deadlock detector", content: "Detects deadlocks from a given graph using the round robin algorithm.  Was developed in C++.",link:"https://github.com/matt200500/Detech-graph-deadlocks" },
  ];

  const changeSlide = (direction) => {
    let newIndex = slideIndex + direction;
    if (newIndex < 0) {
      newIndex = slides.length - 1;
    } else if (newIndex >= slides.length) {
      newIndex = 0;
    }
    setSlideIndex(newIndex);
  };

  return (
    <div className="App">
      <div className="App-header">
        <button className='navbar1' onClick={() => document.getElementById('Home').scrollIntoView({ behavior: 'smooth' })}><FontAwesomeIcon icon={faHome}/></button>
        <button className='navbar' onClick={() => document.getElementById('AboutTop').scrollIntoView({ behavior: 'smooth' })}><FontAwesomeIcon icon={faUser}/></button>
        <button className='navbar' onClick={() => document.getElementById('SkillsTop').scrollIntoView({ behavior: 'smooth' })}><FontAwesomeIcon icon={faCode}/></button>
        <button className='navbar' onClick={() => document.getElementById('ExperienceTop').scrollIntoView({ behavior: 'smooth' })}><FontAwesomeIcon icon={faBriefcase}/></button>
        <button className='navbar' onClick={() => document.getElementById('PortfolioTop').scrollIntoView({ behavior: 'smooth' })}><FontAwesomeIcon icon={faProjectDiagram}/></button>
        <button className='navbar' onClick={() => document.getElementById('ContactTop').scrollIntoView({ behavior: 'smooth' })}><FontAwesomeIcon icon={faEnvelope}/></button>
      </div>
      <section id='Home'>
        <h2 className='Header1'> Hello, My Name Is</h2>
        <h2 className='Header2'> Matthew Cusanelli</h2>
        <h3 className='Header3'> Welcome to my website</h3>

        <a href="https://www.linkedin.com/in/matthew-cusanelli/" target="_blank" rel="noopener noreferrer" className='Link'>
            <FontAwesomeIcon icon={faLinkedin} size="2x" />
          </a>
          <a href="https://github.com/matt200500" target="_blank" rel="noopener noreferrer" className='Link'>
            <FontAwesomeIcon icon={faGithub} size="2x" />
          </a>
          <a className="Link2"href={process.env.PUBLIC_URL + '/Resume Matthew Cusanelli 2026.pdf'}download="Resume Matthew Cusanelli 2026.pdf">
              My Resume
          </a>
          <a
            className="Link2"
            href="https://www.blackjackio.ca/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Blackjack.io
          </a>
          
        <button className='navigation' onClick={() => document.getElementById('ContactTop').scrollIntoView({ behavior: 'smooth' })}>Get in Touch</button>
        <img className="proffesional" src={matteoproffesional} alt="matteoproffesional" />
      </section>


      <section id="AboutTop">
        <h2 className='AboutHeader'>About Me!</h2>
      </section>
      <section id="About">
        <img className="selfie" src={matteoselfie} alt="matteoselfie" />
        <p className='Bio'>I am a passionate and enthusiastic computer science graduate from the University of Calgary. 
          I seek to apply the skills I have gained throughout my years of schooling in the field information and technology science so that I can make a valuable contribution to any team! 
          I am eager learner and I am excited to gain new skills throughout my career in technological development.</p>
      </section>


      <section id="SkillsTop">
        <h2 className='AboutHeader'>My Skills</h2>
      </section>
      <section id="Skills">
        <div className='Backend'>
          <h3 className="FrontendHeader">Languages</h3>
          <div className='BackendContainer'>
            <div className='column'>
              <h4><FontAwesomeIcon icon={faHtml5} size="1x" className='skillIcon'/> HTML</h4>
              <p></p>
              <h4><FontAwesomeIcon icon={faJs} size="1x" className='skillIcon'/>  JavaScript</h4>
              <p></p>
              <h4><FontAwesomeIcon icon={faCss3} size="1x" className='skillIcon'/> CSS</h4>
              <p></p>
            </div>
            <div className='column'>
              <h4><FontAwesomeIcon icon={faPython} size="1x" className='skillIcon'/> Python</h4>
              <p></p>
              <h4><FontAwesomeIcon icon={faJava} size="1x" className='skillIcon'/> Java</h4>
              <p></p>
              <h4><FontAwesomeIcon icon={faCogs} size="1x" className='skillIcon'/> C/C++</h4>
              <p></p>
            </div>
          </div>
        </div>
        <div className="Backend">
          <h3 className="FrontendHeader">Frameworks, tools, and Libraries</h3>
          <div className="BackendContainer">
            <div className="column">
              
              <h4><FontAwesomeIcon icon={faServer} size="1x" className='skillIcon'/> Django</h4>
              <p></p>
              <h4><FontAwesomeIcon icon={faFolder} size="1x" className='skillIcon'/> Docker</h4>
              <p></p>
              <h4><FontAwesomeIcon icon={faReact} size="1x" className='skillIcon'/> React.js</h4>
              <p></p>
            </div>
            <div className="column">
              <h4><FontAwesomeIcon icon={faDatabase} size="1x" className='skillIcon'/> SQL</h4>
              <p></p>
              <h4><FontAwesomeIcon icon={faGit} size="1x" className='skillIcon'/>Git</h4>
              <p></p>
              <h4><FontAwesomeIcon icon={faAws} size="1x" className='skillIcon'/>AWS</h4>
              <p></p>
            </div>
          </div>
        </div>
      </section>

      <section id="ExperienceTop">
        <h2 className='AboutHeader'>My Work Experience</h2>
      </section>
      <section id="Experience">
        <div className='TimelineContainer'>
          <div className='Timelime'>
            <div className='Timeline-item'>
              <div className='Timelime-content'>
                  <h5>September 2021 - April 2026</h5>
                  <h4>Computer Science Student</h4>
                  <h6>University of Calgary</h6>
              </div>
            </div>
            <div className='Timeline-item'>
              <div className='Timelime-content'>
                  <h5>May 2022 - September 2022</h5>
                  <h4>Deckhand</h4>
                  <h6>Heritage Park Historical Village</h6>
                  <p> Assisted thousands of passengers on the ship with information as well as entertainment.
                  Helped maintain the ships functions through cleaning and servicing the ship when needed</p>
              </div>
            </div>
            <div className='Timeline-item'>
              <div className='Timelime-content'>
                  <h5>May 2023 - August 2023</h5>
                  <h4>Customer Service Agent</h4>
                  <h6>Visions Electronics</h6>
                  <p>Assisted thousands of clients with their warranty, damage, and lost parcel claims.
                  Managed files and reports for clients within the vision electronics file database using Microsoft Excel.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="PortfolioTop">
        <h2 className='AboutHeader'> My Recent Projects</h2>
      </section>

      <section id="Portfolio">
        <div className='Slider'>
            {slides.map((slide, index) => (
              <div
                key={index}
                className={`slide ${index === slideIndex ? 'active' : 'hidden'}`}
                style={{
                  opacity: index === slideIndex ? 1 : 0,
                  transform: `translateX(${100 * (index - slideIndex)}%)`
                }}
              >
                <h1>{slide.title}</h1>
                <p>{slide.content}</p>
                <a
            href={slide.link}
            target="_blank"
            rel="noopener noreferrer"
            className={`Link2 ${index === slideIndex ? '' : 'disabled-link'}`}
          >
            Learn More
          </a>
              </div>
            ))}
          </div>
      </section>
      <button className="prev" onClick={() => changeSlide(-1)}><FontAwesomeIcon icon={faArrowLeft} size="2x" /></button>
      <button className="next" onClick={() => changeSlide(1)}><FontAwesomeIcon icon={faArrowRight} size="2x" /></button>
      <section id="ContactTop">
        <h2 className='AboutHeader'>Contact Me</h2>
      </section>
      <section id="Contact">   
        <div className='email'>
          <p> You can reach out to me directly at cusanellim686@gmail.com</p>
          <a href= "mailto: cusanellim686@gmail.com" className='Link2'> Send an Email </a>
        </div>     
      </section>
      <div className='footer'>
        <p> <FontAwesomeIcon icon={faCopyright} size="1x" className='skillIcon'/>Matthew Cusanelli. All rights reserved</p>
      </div>
    </div>
  );
}

export default App;
